angular.module("vgresiduos").controller("CollectionRequestInternalTransferEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `gestao-solicitacoes/transferencia-interna/${$stateParams.id}`);
		};
	}
]);
